import { cn } from '@simplywallst/ui-core/next';

import type { CurrencyISO } from '@/constants/currencies';

import { formatterCurrency } from '@/utilities/format';

type Props = {
  shares: number | null;
  price: number | null;
  currencyISO: CurrencyISO | null;
  currencySymbol?: string;
};

export const TotalCostField = ({
  shares,
  price,
  currencySymbol,
  currencyISO,
}: Props) => {
  if (typeof currencySymbol === 'undefined' || currencyISO === null)
    return null;

  const classes = {
    label: cn(
      'mb-0 text-xs text-soft',
      (shares === null || price === null) && 'text-subtle '
    ),
    cost: cn(
      'text-xs text-soft',
      (shares === null || price === null) && 'text-subtle '
    ),
  };

  let totalCost = currencySymbol;

  if (shares !== null && price !== null) {
    totalCost = formatterCurrency(shares * price, currencyISO);
  }

  return (
    <fieldset className="grid grid-cols-[max-content_1fr] gap-x1">
      <label className={classes.label}>Total cost</label>
      <p className={classes.cost}>{totalCost}</p>
    </fieldset>
  );
};
